import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { fetchUsers } from "@/lib/api";

const wa = (p) => { const d = (p || "").replace(/\D/g, ""); return d.startsWith("07") ? `4${d}` : d; };

export default function BFAgentsWA() {
  const [rows, setRows] = useState(null);
  const [msg, setMsg] = useState("Bună! ");
  useEffect(() => { fetchUsers().then((d) => setRows((d.users || []).filter((u) => (u.role === "agent" || u.role === "admin") && u.share_slug))).catch(() => setRows([])); }, []);
  return (
    <section className="invite-box" data-testid="bf-agents-wa">
      <h3>Agenți pe WhatsApp</h3>
      <p className="st-hint">Scrii mesajul o dată, apoi un tap pe agent deschide WhatsApp cu mesajul gata scris.</p>
      <textarea rows={3} value={msg} onChange={(e) => setMsg(e.target.value)} className="bf-docs-msg" data-testid="bf-agents-wa-msg" />
      <ul className="bfa-leads">
        {(rows || []).map((u) => (
          <li key={u.share_slug} data-testid={`bf-agent-wa-${u.share_slug}`}>
            <div><b>{u.name || u.email}</b><span>{u.role === "admin" ? "admin" : "agent"} · {u.phone || "fără telefon în profil"}</span></div>
            {wa(u.phone) ? <a className="st-btn st-btn--light" href={`https://wa.me/${wa(u.phone)}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer" data-testid={`bf-agent-wa-btn-${u.share_slug}`}><MessageCircle size={14} /> WhatsApp</a>
              : <span className="st-hint">Adaugă telefonul în Utilizatori</span>}
          </li>
        ))}
      </ul>
    </section>
  );
}
